.services {
    display: flex;
    justify-content: center;
    margin-top: 10px;
}